import { render } from "./ScrollSlider.vue?vue&type=template&id=5aeada36"
import script from "./ScrollSlider.vue?vue&type=script&lang=js"
export * from "./ScrollSlider.vue?vue&type=script&lang=js"

import "./ScrollSlider.vue?vue&type=style&index=0&id=5aeada36&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__